import { Button, Tooltip, DatePicker } from '@bancobarigui/barihaus';
import {
  ClearOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { DashboardFilters as DashboardFiltersType } from '../types';

interface DashboardFiltersProps {
  filters: DashboardFiltersType;
  isLoading: boolean;
  onFilterChange: (field: keyof DashboardFiltersType, value: string | undefined) => void;
  onClear: () => void;
  onApply: () => void;
}

export function DashboardFilters({
  filters,
  isLoading,
  onFilterChange,
  onClear,
  onApply,
}: DashboardFiltersProps) {
  const handleStartDateChange = (date: dayjs.Dayjs | null) => {
    onFilterChange('startDate', date?.format('YYYY-MM-DD'));
  };

  const handleEndDateChange = (date: dayjs.Dayjs | null) => {
    onFilterChange('endDate', date?.format('YYYY-MM-DD'));
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-4 mb-6">
      <div className="w-[180px]">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Data Inicial
        </label>
        <DatePicker
          value={filters.startDate ? dayjs(filters.startDate) : null}
          onChange={handleStartDateChange}
          format="DD/MM/YYYY"
          placeholder="Data inicial"
          className="!w-full rounded-lg"
          size="large"
        />
      </div>

      <div className="w-[180px]">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Data Final
        </label>
        <DatePicker
          value={filters.endDate ? dayjs(filters.endDate) : null}
          onChange={handleEndDateChange}
          format="DD/MM/YYYY"
          placeholder="Data final"
          className="!w-full rounded-lg"
          size="large"
        />
      </div>

      <div className="flex items-center gap-2">
        <Tooltip title="Limpar filtros">
          <Button
            icon={<ClearOutlined />}
            onClick={onClear}
            size="large"
            className="rounded-lg"
          >
            Limpar
          </Button>
        </Tooltip>

        <Button
          icon={<FilterOutlined />}
          onClick={onApply}
          loading={isLoading}
          size="large"
          className="rounded-lg !border-0 !bg-[#101010] hover:!bg-[#2a2a2a] !text-white"
        >
          Filtrar
        </Button>
      </div>
    </div>
  );
}
